import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-select-bar',
  templateUrl: './select-bar.component.html',
  styleUrls: ['./select-bar.component.css']
})
export class SelectBarComponent implements OnInit {
  @Input() type;
  @Input() dataArr;
  @Input() category;
  @Output() changeAction = new EventEmitter();
  selectType: boolean;

  constructor() { }

  ngOnInit() {
    this.checkType();

  }
  changeEvent(evt) {

    this.changeAction.emit(evt.target.value);
  }

  checkType() {
    this.selectType = this.type == '2' ? false : true;

  }

}
